module.exports = __webpack_public_path__ + "img/0Q3B3793_L_WoodMatted.1ab03864.jpg";